'use strict';
module.exports = require('../../full/object/get-own-property-symbols');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/get-own-property-symbols.js
// module id = 609
// module chunks = 13